import type DevtoolsStateType from '@/contexts/Devtools/DevtoolsStateType';
import {
  DEVTOOLS_TYPES,
  type DevtoolsReducerActionType,
} from '@/contexts/Devtools/DevtoolsStateType';

export default function devtoolsMemberReducer(
  state: DevtoolsStateType,
  action: DevtoolsReducerActionType
): DevtoolsStateType {
  switch (action.type) {
    case DEVTOOLS_TYPES.MEMBER_SAVE: {
      return {
        ...state,
        member: {
          ...state.member,
          appointments_response: action?.payload?.member?.appointments_response,
          task_health_history: action?.payload?.member?.task_health_history,
          task_terms: action?.payload?.member?.task_terms,
          alert_annual_exam: action?.payload?.member?.alert_annual_exam,
          haveCompletedTasks: action?.payload?.member?.haveCompletedTasks,
          simulateAdvocate: action?.payload?.member?.simulateAdvocate,
        },
      };
    }
    case DEVTOOLS_TYPES.MEMBER_RESET: {
      return {
        ...state,
        member: {},
      };
    }
    default:
      return state;
  }
}

export const actions: DEVTOOLS_TYPES[] = [
  DEVTOOLS_TYPES.MEMBER_SAVE,
  DEVTOOLS_TYPES.MEMBER_RESET,
];
